import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';

/**
 * Título del registro abierto, para que el breadcrumb del layout muestre
 * «Productos › IN1489 · Teclado…» en vez de «Productos › Detalle». La página
 * de detalle lo fija con `useTituloRegistro(...)` y se limpia al desmontar.
 * También alimenta document.title.
 */

type Ctx = { titulo: string | null; setTitulo: (t: string | null) => void };
const TituloContext = createContext<Ctx>({ titulo: null, setTitulo: () => {} });

export function TituloRegistroProvider({ children }: { children: ReactNode }) {
  const [titulo, setTitulo] = useState<string | null>(null);
  const value = useMemo(() => ({ titulo, setTitulo }), [titulo]);
  useEffect(() => { document.title = titulo ? `${titulo} · PM-APPROX` : 'PM-APPROX'; }, [titulo]);
  return <TituloContext.Provider value={value}>{children}</TituloContext.Provider>;
}

export function useTituloRegistro(titulo: string | null | undefined): void {
  const { setTitulo } = useContext(TituloContext);
  useEffect(() => {
    setTitulo(titulo ?? null);
    return () => setTitulo(null);
  }, [titulo, setTitulo]);
}

export function useTituloActual(): string | null {
  return useContext(TituloContext).titulo;
}
